import { useState } from 'react';

import { cn } from '@/lib/utils';

import Chip from './chip';
import type { ChipProps } from './chip';

export type ChipListProps = {
  items: string[];
  max?: number;
  variant?: ChipProps['variant'];
  size?: ChipProps['size'];
  className?: string;
};

function ChipList({
  items,
  max = 3,
  variant = 'neutral',
  size = 'sm',
  className,
}: Readonly<ChipListProps>) {
  const [expanded, setExpanded] = useState(false);

  if (!items.length) return null;

  const overflow = items.length - max;
  const visible = expanded || overflow <= 0 ? items : items.slice(0, max);
  const overflowLabel = expanded ? 'Show less' : `+${overflow}`;

  const handleToggleOverflow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {visible.map((item) => (
        <Chip key={item} size={size} variant={variant}>
          {item}
        </Chip>
      ))}
      {overflow > 0 && (
        <button
          type="button"
          onClick={handleToggleOverflow}
          className="bg-muted text-muted-foreground hover:bg-muted-hover relative z-10 inline-flex cursor-pointer items-center rounded-full px-2 py-0.5 text-xs font-medium transition-colors"
        >
          {overflowLabel}
        </button>
      )}
    </div>
  );
}

export { ChipList };
export default ChipList;
